/**
 * Replica Service
 * 
 * Handles replica (public) pages with referral tracking
 * Phase 2-B: Added withCredentials + fixed Content-Type for FormData
 */

import axios from "axios";
import replicaAPI from "../../api/replicaApi";
import { BASE_URL, DEFAULT_KEY } from "../../config/config";

const callApi = async (endpoint) => {
  try {
    const response = await replicaAPI.get(endpoint);
    if (response.status === 200) {
      return response?.data;
    } else {
      return response;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ReplicaService = {
  getApiKey: async (admin) => {
    const adminUsername = admin ?? localStorage.getItem("admin_user_name");
    const response = await callApi(
      `get-api-key?admin_username=${adminUsername}`
    );
    return response;
  },
  getReplicaHome: async () => {
    const response = await callApi("replica-home");
    return response;
  },
  getReplicaRegister: async () => {
    const response = await callApi("replica-register-get");
    return response;
  },
  getFieldCheck: async (field, value) => {
    const response = await callApi(
      `replica-checkUsernameEmail?field=${field}&value=${value}`
    );
    return response;
  },
  callBankUpload: async (data, username, referralId, type) => {
    const formData = new FormData();
    formData.append("file", data);
    formData.append("username", username);
    formData.append("referralId", referralId);

    // Create a new Axios instance for this specific request
    // Phase 2-B: Added withCredentials, removed explicit Content-Type for FormData
    const customAxios = axios.create({
      baseURL: BASE_URL,
      withCredentials: true, // Required for session cookies
    });

    // Set api-key header (no access-token in Phase 2-B)
    customAxios.defaults.headers.common["api-key"] = DEFAULT_KEY;

    // NOTE: Do NOT set Content-Type for FormData - browser will set it with boundary
    // customAxios.defaults.headers.common["Content-Type"] = "multipart/form-data"; // REMOVED

    try {
      const response = await customAxios.post(
        `replica-payment-receipt-upload?type=${type}`,
        formData
      );
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  ReplicaBankRecieptDelete: async (data) => {
    return replicaAPI
      .post(`replica-payment-receipt-delete`, data)
      .then((response) => response.data)
      .catch((error) => error);
  },
  CallReplicaRegister: async (data) => {
    return replicaAPI
      .post("replica-register-post", JSON.stringify(data))
      .then((response) => response.data)
      .catch((error) => error);
  },
  replicaContactUpload: async (data) => {
    return replicaAPI
      .post("replica-contact-upload", JSON.stringify(data))
      .then((response) => response.data)
      .catch((error) => error);
  },
  replicaCreateStripePaymentIntent: async (data) => {
    return replicaAPI
      .post("replica-create-stripe-payment-intent", JSON.stringify(data))
      .then((response) => response.data)
      .catch((error) => error);
  },
  replicaUpdateStripePaymentIntent: async (data) => {
    return replicaAPI
      .post("replica-update-stripe-payment-intent", JSON.stringify(data))
      .then((response) => response.data)
      .catch((error) => error);
  },
  replicaCancelStripePaymentIntent: async (data) => {
    return replicaAPI
      .post("replica-cancel-stripe-payment-intent", JSON.stringify(data))
      .then((response) => response.data)
      .catch((error) => error);
  },
  verifyCaptcha: async (data) => {
    return replicaAPI
      .post("verify-captcha", JSON.stringify(data))
      .then((response) => response.data)
      .catch((error) => error);
  },
  sendVerificationMail: async (data) => {
    return replicaAPI
      .post("sent-mail", JSON.stringify(data))
      .then((response) => response.data)
      .catch((error) => error);

  },
  verifyToken: async (token) => {
    const response = await callApi(
      `verify-mail?token=${token}`
    );
    return response;
  },
  verifyPinNumber: async (data) => {
    return replicaAPI
      .post("verify-epin", JSON.stringify(data))
      .then((response) => response.data)
      .catch((error) => error);
  }
};
